import raw from "./zonesCR.json";

/**
 * Convierte el JSON del gist a:
 * { Provincia: { Canton: [Distritos...] } }
 */
export const ubicacionesCR = (() => {
  const out = {};
  const provincias = raw.provincias;

  for (const provCode of Object.keys(provincias)) {
    const prov = provincias[provCode];
    const provName = prov.nombre;
    out[provName] = {};

    const cantones = prov.cantones;
    for (const cantCode of Object.keys(cantones)) {
      const cant = cantones[cantCode];
      // a veces el gist tiene cantones como string, por si acaso
      if (typeof cant === "string") continue;

      const cantName = cant.nombre;
      const distritosObj = cant.distritos || {};
      out[provName][cantName] = Object.values(distritosObj);
    }
  }

  return out;
})();
